import React, { useMemo } from 'react';

import BrokerFilter from 'components/search_sidebar/broker_filter';

import type { Filters } from './types';
import type { Props as FilterProps } from './index';

type Slice = Pick<Filters, 'assigneeId'>;
interface Props extends Slice {
  users: FilterProps['options']['users'];
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ assigneeId, users, onChange }: Props) {
  const options = useMemo(() => [{ name: 'All Assignees' }, ...users], []);

  return (
    <BrokerFilter
      autoWidth
      brokers={options}
      menuPosition="fixed"
      selectedBrokerId={assigneeId}
      onChange={user => onChange({ assigneeId: user?.id || null })}
      onClear={assigneeId ? () => onChange({ assigneeId: null }) : null}
    />
  );
}
